export const cleanSymbolsOnDecimal = (value: string): string => {
  if (value.includes(',')) {
    const [integerPart, decimalPart] = value.split(',');
    return `${integerPart},${decimalPart.replace(/\./g, '')}`;
  }
  return value;
};
